<template>
  <div class="body-empty-layout">
    <slot />
  </div>
</template>
